export default {
    inputInserted(type) {
        gtag('event', 'link_insert');
    },
    searchClicked() {
        gtag('event', 'link_submit');
    },
    errorOccured(error) {
        gtag('event', 'vidacha_error', {
            'errror_type': error
        });
    },
    resultReceived() {
        gtag('event', 'vidacha_show');
    },
    sendDownloadFormat(type) {
        gtag('event', 'vidacha_download_click', {
            'format': type
        })
    }
}
